export default "__VITE_PUBLIC_ASSET__1a140837__"